module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-month-bc85f186.svg";